<template>
    <div class="list-group border-radius-2 no-border">
        <div class="list-group-item">
            <CheckboxInput 
                v-if="!alwaysShow" 
                :value="showSettings" 
                @input="toggleRecur"
                :label="$t('recur')" 
                :class="{'mb-0': !showSettings}"
            />

            <div v-if="showSettings" class="d-flex flex-column align-items-start">
                <SelectInput
                    :label="$t('period')"
                    v-model="event.recur_period"
                    :options="{'1W': $t('every-week'), '2W': $t('every-two-weeks'), '4W': $t('every-four-weeks'), '1D': $t('daily')}"
                    :indexIsValue="true"
                    :nullable="false"
                />

                <!-- Recur Limit? -->
                <div v-if="event.recur_period">
                    <CheckboxInput :value="setALimit" :label="$t('set-limit')" @input="toggleSetALimit"/>

                    <div v-if="setALimit" class="d-flex flex-row align-items-center" style="gap: 1rem;">
                        <NumberInput :label="$t('for')" :srOnly="true" v-model="event.recur_count" :min="2" />
                        <span class="pb-3">{{ $t('events') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckboxInput from 'src/components/Inputs/CheckboxInput.vue'
import SelectInput from 'src/components/Inputs/SelectInput.vue'
import NumberInput from 'src/components/Inputs/NumberInput.vue'

export default {
    components: {
        CheckboxInput,
        SelectInput,
        NumberInput,
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
        alwaysShow: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showSettings: this.alwaysShow,
            setALimit: true,
        }
    },
    methods: {
        toggleRecur() {
            if (this.alwaysShow) return

            if (this.showSettings) {
                this.showSettings = false
                delete this.event.recur_count
                delete this.event.recur_period
            } else {
                this.showSettings = true
                this.event.recur_count = 2
                this.event.recur_period = '1W'
            }
        },
        toggleSetALimit() {
            if (this.setALimit) {
                this.setALimit = false
                this.event.recur_count = -1
            } else {
                this.setALimit = true
                this.event.recur_count = 2
            }
        }
    },
}
</script>